import React from "react";

export default function DisplayMovies({ userData }) {
	return (
		<div className="mb-3">
			<p className="mt-2">
				<i className="bi bi-film"></i> <span>TV / Film</span>
			</p>

			{userData?.movies?.map((movie, i) => (
				<span key={i} className="badge custom-badge rounded-pill text-bg-secondary me-2 mb-1">
					<i className="bi bi-film"></i> {movie}
				</span>
			))}

			{!userData?.movies?.length && <div>(Add TV / Films you've enjoyed)</div>}
		</div>
	);
}
